module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/icn-no1-60ab8eebb0b901395be0014ffd23a3ba.svg";